__turbopack_context__.v({
  "accordion": "Accordion-module-scss-module__jrzj7W__accordion",
  "accordionContent": "Accordion-module-scss-module__jrzj7W__accordionContent",
  "accordionHeader": "Accordion-module-scss-module__jrzj7W__accordionHeader",
  "accordionItem": "Accordion-module-scss-module__jrzj7W__accordionItem",
  "contentInner": "Accordion-module-scss-module__jrzj7W__contentInner",
  "icon": "Accordion-module-scss-module__jrzj7W__icon",
  "open": "Accordion-module-scss-module__jrzj7W__open",
  "rotate": "Accordion-module-scss-module__jrzj7W__rotate",
  "title": "Accordion-module-scss-module__jrzj7W__title",
});
